module.exports = __webpack_public_path__ + "img/film-02.bb569347.svg";